import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';

class VisualComponent extends BasicComponent {
    getType() { return "VisualComponent"; }

    constructor( { id } = {} ) {
        super( { id });

        this.material = null;
        this.texture = null;
        this.mesh = null;
        this.scene = null;
        this.scaleFactor = 1;
    }

    setScaleFactor( value ){
        this.scaleFactor = value;
    }

    construct( context, prefab ) {
        // Base
        const base = super.construct( context, prefab ).getRootNode();
        base.position = prefab.getPosition();
        if((prefab.getRotationX() && prefab.getRotationX() != 0) || (prefab.getRotationY() && prefab.getRotationY() != 0) || (prefab.getRotationZ() && prefab.getRotationZ() != 0)){
            base.rotation = new BABYLON.Vector3(prefab.getRotationX()* Math.PI / 180, prefab.getRotationY()* Math.PI / 180, prefab.getRotationZ()* Math.PI / 180);
        }else{
            base.lookAt(new BABYLON.Vector3(0,0,0));
        }

        this.scene = window.scene;
       
        if(!prefab.getIconID())
            return undefined;
        
        // Texture (Creat texture out of Bitmap that was loaded inside preloadSituation() in PanoramaScene.vue)
        this.texture = MediaManager.getMedia(prefab.getIconID());
        let texture = BABYLON.RawTexture.CreateRGBATexture(this.texture.blob, this.texture.blob.width, this.texture.blob.height, window.scene, true, true, BABYLON.Texture.TRILINEAR_SAMPLINGMODE);
        texture.wrapU = texture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;
        texture.uScale = texture.uScale = texture.vScale = texture.vScale = -1;
        texture.name = this.texture.id;

        // Material
        this.material = new BABYLON.StandardMaterial("VisualComponentImage_" + prefab.getIconID() + "_material", this.scene);
        this.material.disableLighting = true;   
        this.material.emissiveTexture = this.material.opacityTexture = texture;

        // Mesh
        this.mesh = BABYLON.MeshBuilder.CreatePlane("VisualComponentImage_" + prefab.getIconID(), { 
            width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
            height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE 
        }, window.scene);
        this.mesh.parent = base;
        this.mesh.material = this.material;

        return base;
    }
}

export default VisualComponent;

